module.exports = __webpack_public_path__ + "static/img/left-top-row-1.b6f879da.webp";